/**
 * ProfileSection — an always-open, headed card of the marketing editor, a peer of the Description and
 * Photos cards. Nothing is collapsed: every field is on the page the moment the editor renders.
 */

import { useId, type ReactNode } from 'react';

interface Props {
  title: string;
  /** Prefix-stable test id of the section wrapper. */
  testId: string;
  /** Muted text beside the heading (e.g. "3 selected"). Outside the heading, so it is not part of the section's accessible name. */
  aside?: string;
  children: ReactNode;
}

export function ProfileSection({ title, testId, aside, children }: Props) {
  const headingId = useId();
  return (
    <section aria-labelledby={headingId} data-testid={testId} className="rounded-lg border border-border bg-card p-4 md:p-6">
      <div className="mb-3 flex items-baseline gap-2">
        <h2 id={headingId} className="text-base font-semibold text-foreground">
          {title}
        </h2>
        {aside && (
          <span className="text-xs text-muted-foreground" data-testid={`${testId}-aside`}>
            {aside}
          </span>
        )}
      </div>
      {children}
    </section>
  );
}
